import useAuthGetters from './useAuthGetters';
import {
  ClientsClient,
  EmployeesClient,
  ProjectsClient,
  TeamsClient,
  PrioritiesClient,
  RolesClient,
  ManagerProxyClient,
} from '../api';
import { ApiBase } from '../api/ApiBase';

const useAuthenticatedClients = () => {
  const { getApiAuth } = useAuthGetters();

  const applyAuth = async <T extends ApiBase>(client: T) => {
    const auth = await getApiAuth();
    client.setAuthorization(auth.accessToken);
    return client;
  };

  const getClientsClient = async () => {
    const client = new ClientsClient();
    const clientWithAuth = applyAuth(client);
    return clientWithAuth;
  };

  const getEmployeesClient = async () => {
    const client = new EmployeesClient();
    const clientWithAuth = applyAuth(client);
    return clientWithAuth;
  };

  const getRolesClient = async () => {
    const client = new RolesClient();
    const clientWithAuth = applyAuth(client);
    return clientWithAuth;
  };

  const getProjectsWithPriorities = async () => {
    const client = new ProjectsClient();
    const clientWithAuth = applyAuth(client);
    return clientWithAuth;
  };

  const getProjectsClient = async () => {
    const client = new ProjectsClient();
    const clientWithAuth = applyAuth(client);
    return clientWithAuth;
  };

  const getTeamsClient = async () => {
    const client = new TeamsClient();
    const clientWithAuth = applyAuth(client);
    return clientWithAuth;
  };

  const getPrioritiesClient = async () => {
    const client = new PrioritiesClient();
    const clientWithAuth = applyAuth(client);
    return clientWithAuth;
  };

  const getManagerProxyClient = async () => {
    const client = new ManagerProxyClient();
    const clientWithAuth = applyAuth(client);
    return clientWithAuth;
  };

  return {
    getClientsClient,
    getEmployeesClient,
    getProjectsClient,
    getRolesClient,
    getProjectsWithPriorities,
    getTeamsClient,
    getPrioritiesClient,
    getManagerProxyClient,
  };
};

export default useAuthenticatedClients;
